import React from 'react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';

const LAST_UPDATED = 'July 20, 2026';

const DataCollectionPolicy = () => (
  <PageShell trackPage="/data-collection-policy">
    <SEO title="Data Collection Policy | Amigo's Bail Bonds" description="Details on the analytics, attribution, and consent data Amigo's Bail Bonds collects and why." path="/data-collection-policy" />
    <div className="page-hero">
      <div className="eyebrow">LEGAL</div>
      <h1 className="section-title">DATA COLLECTION POLICY</h1>
      <p className="section-subtitle" style={{ margin: '0 auto' }}>Last updated: {LAST_UPDATED}</p>
    </div>
    <section className="section section--void">
      <div className="container prose" style={{ maxWidth: 780 }}>
        <p>This policy describes, in plain language, the specific data points our website and intake system collect, and why each one is collected.</p>

        <h2>Form Submission Data</h2>
        <ul>
          <li><strong>Requester &amp; defendant details</strong> — needed to identify the case and process a bail bond request.</li>
          <li><strong>Callback phone &amp; preferred contact method</strong> — needed to reach you as quickly as possible.</li>
          <li><strong>Consent status</strong> — recorded with a timestamp to document your permission for us to call or text you, per TCPA guidance. We never use a pre-checked consent box.</li>
        </ul>

        <h2>Attribution &amp; Analytics Data</h2>
        <ul>
          <li><strong>UTM parameters, referrer, landing page</strong> — collected only from the URL when you arrive, to understand which campaign or search led you here.</li>
          <li><strong>First-party visitor ID</strong> — a random identifier stored in your browser&apos;s local storage (not a third-party cookie) so we can connect your on-site actions (page views, clicks, form progress) to a single visit without identifying you personally until you submit a form.</li>
          <li><strong>Device type, browser, and language</strong> — used to understand how our site performs across devices and to route Spanish-language requests appropriately.</li>
          <li><strong>Event tracking</strong> — we record specific interactions (e.g. phone number clicks, form step completions, FAQ expansions) in aggregate to identify where visitors need more help. This data is analyzed in aggregate and tied to your visitor ID, not sold to third parties.</li>
        </ul>

        <h2>What We Do Not Do</h2>
        <ul>
          <li>We do not use third-party advertising trackers or sell browsing data.</li>
          <li>We do not collect data via camera, microphone, or precise device location.</li>
          <li>We do not pre-check consent boxes or use dark patterns to obtain consent.</li>
        </ul>

        <h2>Data Retention</h2>
        <p>Case-related records (including consent records) are retained consistent with applicable bail bond industry recordkeeping requirements. Aggregate analytics data may be retained longer in de-identified form to support long-term reporting.</p>

        <h2>Staff Access &amp; Security</h2>
        <p>Access to lead and case data is restricted by role-based permissions, protected by password authentication, and logged in an immutable audit trail recording who viewed or changed what, and when.</p>

        <p style={{ color: 'var(--text-dim)', fontSize: '0.82rem', marginTop: '2rem' }}>
          Version 1.0 · Created {LAST_UPDATED} · Last Modified {LAST_UPDATED}
        </p>
      </div>
    </section>
  </PageShell>
);

export default DataCollectionPolicy;
